import FilterDefinition from 'helpers/search_filters/filter_definition';
import EnumFormatter from '../../search_filters/formatters/enum_formatter';
import { propertyTypeMappings } from '../../property_types';

import AddressFilterDefinitions from './address_filters';
import PropertyFilterDefinitions from './property_filters';

export const propertyTypes = new FilterDefinition({
  label: 'Property Type',
  value: query => query.propertyTypes,
  formatter: new EnumFormatter(propertyTypeMappings),
});

export const transactionTypes = new FilterDefinition({
  label: 'Transaction Type',
  value: query => query.transactionTypes,
  formatter: new EnumFormatter({
    1: 'Sale',
    2: 'Lease'
  }),
});

export const searchText = new FilterDefinition({
  label: 'Contains text',
  value: query => query.searchText
});

const filters = [
  searchText,
  propertyTypes,
  ...AddressFilterDefinitions,
  ...PropertyFilterDefinitions
];

export default filters;
